<template>
  <div class="header_menu">
    <el-menu
      :default-active="activeIndex2"
      class="el-menu-demo"
      mode="horizontal"
      router="true"
      unique-opened="true"
      background-color="none"
      active-text-color="#FFCC00"
      @select="handleSelect"
    >
      <template v-for="(item, index) in menuList" :key="index">
        <el-menu-item v-if="item.type == 'item'" :index="item.index">{{
          item.lable
        }}</el-menu-item>
        <el-sub-menu
          v-else-if="item.type == 'submenu'"
          :index="index"
          popper-class="sub_menu"
          popper-append-to-body="true"
        >
          <template #title>{{ item.lable }}</template>
          <template
            v-for="(itemChild, indexChild) in item.childs"
            :key="indexChild"
          >
            <el-menu-item :index="itemChild.index">{{
              itemChild.lable
            }}</el-menu-item>
          </template>
        </el-sub-menu>
      </template>
    </el-menu>
  </div>
</template>

<script lang="ts">
import { routerList } from '@/api/index';
import { reactive, ref, toRefs,defineComponent, onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  // name:'courceDetails',、
  setup() {
    const activeIndex2 = ref("/");
    const routerData = ref<Array<any>>([])
    const menu = reactive({
      menuList: [
        {
          id: 0,
          type: "item",
          index: "/",
          lable: "首页",
          icon: "el-icon-circle-plus-outline",
          route: {
            type: "inner",
            path: { name: "KgGainIframe", params: { postfix: "D2R" } },
          },
        },
        {
          id: 1,
          type: "submenu",
          index: "",
          lable: "全部节目",
          icon: "ic-association-analysis",
          childs: [
            {
              id: 0,
              // type: "item",
              index: "/basicCourse",
              lable: "100+门通识基础课",
              // route: {
              //   type: "inner",
              //   path: { name: "basicCourse" },
              // },
            },
            {
              id: 1,
              type: "item",
              index: "classicGuide",
              lable: "100+本人类经典导读",
              route: {
                type: "inner",
                path: { name: "classicGuide" },
              },
            },
            {
              id: 2,
              type: "item",
              index: "famousTeacher",
              lable: "200+位名师",
              route: {
                type: "inner",
                path: { name: "famousTeacher" },
              },
            },
            {
              id: 3,
              type: "item",
              index: "subject",
              lable: "学科入门",
              route: {
                type: "inner",
                path: { name: "subject" },
              },
            },
            {
              id: 4,
              type: "item",
              index: "world",
              lable: "看世界",
              route: {
                type: "inner",
                path: { name: "world" },
              },
            },
            {
              id: 5,
              type: "item",
              index: "headLine",
              lable: "知鸦头条",
              route: {
                type: "inner",
                path: { name: "headLine" },
              },
            },
            
          ],
        },
        {
          id: 11,
          type: "submenu",
          index: "about",
          lable: "关于我们",
          icon: "el-icon-circle-plus-outline",
          // route: {
          //   type: "inner",
          //   path: { name: "KgGainIframe", params: { postfix: "D2R" } },
          // },
          childs: [
            {
              id: 10,
              type: "item",
              index: "contenUs",
              lable: "联系我们",
              icon: "el-icon-circle-plus-outline",
              route: {
                type: "inner",
                path: { name: "KgGainIframe", params: { postfix: "D2R" } },
              },
            },
            {
              id: 10,
              type: "item",
              index: "joinUS",
              lable: "加入我们",
              icon: "el-icon-circle-plus-outline",
              route: {
                type: "inner",
                path: { name: "KgGainIframe", params: { postfix: "D2R" } },
              },
            },
          ],
        },
      ],
    })
    const route = useRoute()

    onBeforeMount(()=>{
      activeIndex2.value = (route.meta.index as string)
      routerList().then((res:any)=>{
        if(res.code == 0){
        menu.menuList[1].childs = res.data;
        }
      })
    })

    const handleSelect = (key: string, keyPath: string[]) => {
      console.log(key, keyPath);
    };
    
    return {
      activeIndex2,
      ...toRefs(menu),
    }
  }
})

</script>

<style scoped>

.header_menu {
  height: 100%;
}
.el-menu--horizontal {
  border-bottom: none;
  height: 100%;
}
.el-menu-item {
  padding: 0;
}
.el-menu--horizontal > li {
  position: relative;
  margin-left: 70px;
}
.el-menu--horizontal > li.is-active::after {
  position: absolute;
  width: 28px;
  left: 50%;
  transform: translateX(-50%);
  content: "";
  display: block;
  height: 6px;
  background: #ffcc00;
  border-radius: 3px;
  bottom: 0;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  background: transparent !important;
}
.el-menu--horizontal > .el-menu-item {
  color: #fff;
}

</style>
<style>
.el-popper.is-light{
  border: none !important;
  /* border-color: red; */
}
.el-menu--horizontal > .el-sub-menu.is-active .el-sub-menu__title {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-sub-menu .el-sub-menu__title:hover {
  background-color: transparent !important;
}
.el-menu--horizontal > .el-sub-menu {
  background-color: transparent !important;
}
.el-menu--horizontal > .el-sub-menu .el-sub-menu__title {
  color: #fff !important;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #ffcc00 !important;
  background-color: transparent !important;
}
.el-menu--horizontal > .el-sub-menu .el-sub-menu__icon-arrow {
  display: none !important;
}
.el-sub-menu__title {
  padding: 0 !important;
}
.el-input__inner:focus {
  border-color: #ffcc00;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover{
  background: transparent !important;
  color: #ffcc00 !important;
}
.sub_menu {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 7px 9px -1px rgba(0, 0, 0, 0.06);
  margin-top: -8px;
  margin-left: -72px;
}
</style>